import Input from "../../components/Input/Input";
import { useEffect, useState } from "react";
import { useContextTranslate } from "../../components/Translate/ContextProvider";
import { Container } from "../../components";
import { usePOST } from "../../Tools/APIs";
import Loading from "../../Tools/Loading";
function SetPassword() {
  const [password, setPassword] = useState(false);
  const { content } = useContextTranslate();
  const {
    setFormData,
    handleSubmit,
    error,
    loading,
    handleChangeInput,
    formData,
  } = usePOST({});
  const handleSubmitMain = (e) => {
    e.preventDefault();
    handleSubmit("password/reset", "/login");
  };
  useEffect(() => {
    setFormData({
      ...formData,
      verification_code: sessionStorage.getItem("code"),
      email: sessionStorage.getItem("email"),
    });
  }, []);
  return (
    <Container>
      <div className="w-1/2 max-lg:w-full mx-auto bg-gradient-to-t from-[#E00201] to-[#062371] p-2 rounded-2xl overflow-hidden my-10">
        <div className="bg-gray-200 flex flex-col justify-center space-y-6 border border-Blu sm:p-10 max-sm:p-4 rounded-2xl">
          <h1 className="text-2xl font-semibold max-xsm:text-lg">
            {content.NewPassword}
          </h1>
          <Input
            type={!password ? "password" : "text"}
            title={content.SetPassword}
            name="password"
            onChange={handleChangeInput}
          />
          <Input
            type={!password ? "password" : "text"}
            title={content.ConfirmPassword}
            name="password_confirmation"
            onChange={handleChangeInput}
          />
          <div className="text-lg mt-5 flex items-center justify-center">
            <input
              type="checkbox"
              onChange={(e) => setPassword(e.target.checked)}
              name="checkbox"
              className="mx-3 w-fit"
            />
            <span>{content.showPassword}</span>
          </div>
          {loading ? <Loading /> : ""}
          <div className="text-red-600">{error}</div>
          <div className="w-fit mx-auto">
            <button
              className="border px-10 max-xsm:px-2 border-Main hover:text-white text-Main hover:bg-Main bg-white font-semibold p-3 rounded-xl"
              type="submit"
              onClick={handleSubmitMain}
            >
              {content.ConfirmPassword}
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
}
export default SetPassword;
